export default "__VITE_ASSET__CGpf2emG__"